import React from 'react';

const PasswordStrengthWarn = ({ translate }) => (
  <div
    className="alert alert-success password-must-contain  password-must-contain--blue">
    <strong>{translate('session.common.texts.text_password_must')}</strong>
    <p>{translate('session.common.texts.text_password_contains')}</p>
  </div>
);

export default PasswordStrengthWarn;



// WEBPACK FOOTER //
// ./src/components/common/form/passwordStrengthWarn.js